import type { OrderDto } from "../api/types";

type OrderStatus = OrderDto["status"];
type PaymentStatus = OrderDto["paymentStatus"];

const NBSP = " ";

export function money(value: number | null | undefined): string {
  return `${Math.round(value ?? 0).toLocaleString("ru-RU").replace(/\s/g, NBSP)}${NBSP}₽`;
}

export function dateTime(value: string | Date | null | undefined): string {
  if (!value) return "—";
  return new Date(value).toLocaleString("ru-RU", {
    day: "2-digit",
    month: "2-digit",
    hour: "2-digit",
    minute: "2-digit"
  });
}

export function timeOnly(value: string | Date | null | undefined): string {
  if (!value) return "—";
  return new Date(value).toLocaleTimeString("ru-RU", { hour: "2-digit", minute: "2-digit" });
}

/** Прошедшее время в формате мм:сс — так его легче сравнивать взглядом. */
export function elapsed(from: string | Date | null | undefined, now = Date.now()): string {
  if (!from) return "—";
  const seconds = Math.max(0, Math.floor((now - new Date(from).getTime()) / 1000));
  const minutes = Math.floor(seconds / 60);

  if (minutes >= 60) {
    return `${Math.floor(minutes / 60)}${NBSP}ч ${String(minutes % 60).padStart(2, "0")}${NBSP}мин`;
  }
  return `${String(minutes).padStart(2, "0")}:${String(seconds % 60).padStart(2, "0")}`;
}

export function minutesSince(from: string | Date | null | undefined, now = Date.now()): number {
  if (!from) return 0;
  return Math.floor((now - new Date(from).getTime()) / 60000);
}

/**
 * Подпись исключения ингредиента.
 *
 * Администратор может назвать модификатор и «Лук», и «Без лука» — приписывать
 * «без» во втором случае нельзя, иначе на кухонном чеке окажется «без Без лука».
 */
export function exclusionLabel(title: string): string {
  return /^без\s/i.test(title.trim()) ? title.trim() : `без ${title.trim()}`;
}

export const ORDER_STATUS_LABELS: Record<OrderStatus, string> = {
  awaiting_payment: "Ожидает оплаты",
  payment_failed: "Оплата не прошла",
  paid: "Оплачен",
  accepted: "Принят",
  cooking: "Готовится",
  ready: "Готов",
  picked_up: "У доставщика",
  delivered: "Доставлен",
  handed: "Выдан",
  cancelled: "Отменён"
};

export const PAYMENT_STATUS_LABELS: Record<PaymentStatus, string> = {
  created: "Создан",
  pending: "Ожидает",
  paid: "Оплачен",
  cancelled: "Отменён",
  error: "Ошибка",
  partial_refund: "Частичный возврат",
  full_refund: "Полный возврат",
  refund_processing: "Возврат в обработке",
  refund_error: "Ошибка возврата"
};

/** Статусы, которые клиент видит на своей странице (п. 9.1 ТЗ). */
export const CLIENT_STATUS_LABELS: Record<OrderStatus, string> = {
  ...ORDER_STATUS_LABELS,
  paid: "Оплата прошла",
  accepted: "Заказ принят",
  cooking: "Заказ готовится",
  ready: "Заказ готов",
  picked_up: "Сотрудник несёт заказ к лавочке",
  delivered: "Заказ доставлен",
  handed: "Заказ выдан"
};
